import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import Archive_icon from './Archive_icon'
import Markread from './Markread'
import firebase from "../../firebase/firebase-config";
import { Link } from 'react-router-dom';

const SingleFeedback = ({ data }) => {
    const [user, setuser] = useState({})
    const [mydate, setdate] = useState()


    const get_data = () => {
        const dates = new Date(data.createdOnDate);
        setdate(dates.toUTCString());

    }

    useEffect(() => {
        get_data();
    }, [])

    return (
        <>
            <div className="border shadow-lg   my-2" style={{ borderRadius: '12px' }}>
                <Row>
                    <Col xs="8">

                        <Link to={`/admin/Feed-backs/single/${data?.id}`}
                            //  to={`/admin/Feed-backs/${data?.id}`}
                            style={{ zIndex: 20 }}>
                            <div className="d-flex p-3  justify-content-between  align-items-center " style={{ borderRadius: '12px' }} >

                                <p className="font-weight-bolder" style={{ width: '200px' }}  >{data?.email}</p>

                                <p className="font-weight-bolder" style={{ width: '200px' }} >{data?.subject}</p>
                                <div style={{ width: '300px' }}>
                                    <p>{data?.message}</p>
                                </div>



                            </div>



                        </Link>
                    </Col>
                    <Col xs='4' className='d-flex justify-content-between align-items-center '>
                        <p className='align-items-center'>{mydate}</p>


                        <div className="d-flex p-3 justify-content-end align-items-center  " style={{ width: '100px', zIndex: 25 }}>

                            <div className="px-2" onClick={(e) => {
                                console.log('archived clicked');
                            }} style={{ cursor: 'pointer' }} >
                                <Archive_icon width='1.5em' height='1.5em' />
                            </div>

                            <i className="tim-icons icon-trash-simple px-2" onClick={(e) => {
                                console.log('delete clicked');
                            }} style={{ cursor: 'pointer' }} />
                            <div className="px-2" onClick={(e) => {
                                console.log('markRead clicked');
                            }} style={{ cursor: 'pointer' }}>
                                <Markread />
                            </div>
                        </div>
                    </Col>

                </Row>
            </div>

        </>
    )
}

export default SingleFeedback